import { useQuery } from "react-query";
import { getBusinessLicenseByOfficeId } from "../../../../actions/CarrierAgreementMgmt/BusinessLicensesAndPermits";

export const useGetBusinessLicenseByOfficeId = (officeId) => {
  return useQuery(
    ["GetBusinessLicenseByOfficeId", officeId],
    () => getBusinessLicenseByOfficeId(officeId),
    { refetchOnWindowFocus: false }
  );
};
